var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuality(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M41.58,43.08a29.57,29.57,0,0,0-8.69,14,12.08,12.08,0,0,0,1,1.83C38.7,66.5,49.27,67.6,56,61.58c3.1-2.8,8.17-6.19,14.55-6.19V32.33A40.58,40.58,0,0,0,41.58,43.08Z",
    style: {
      fill: "#223773"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 73.27,
    y1: 18.4,
    x2: 73.27,
    y2: 6.01,
    style: {
      fill: "none",
      stroke: "#223773",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56.3,
    y1: 21.4,
    x2: 51.75,
    y2: 8.87,
    style: {
      fill: "none",
      stroke: "#223773",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40.42,
    y1: 29.05,
    x2: 32.07,
    y2: 19.1,
    style: {
      fill: "none",
      stroke: "#223773",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30.27,
    y1: 39.62,
    x2: 18.46,
    y2: 32.81,
    style: {
      fill: "none",
      stroke: "#223773",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 118.18,
    y1: 42.25,
    x2: 128.28,
    y2: 36.41,
    style: {
      fill: "none",
      stroke: "#223773",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 107.16,
    y1: 30.14,
    x2: 115.25,
    y2: 20.51,
    style: {
      fill: "none",
      stroke: "#223773",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.24,
    y1: 22.36,
    x2: 94.78,
    y2: 9.91,
    style: {
      fill: "none",
      stroke: "#223773",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.89,57.08a12.08,12.08,0,0,0,1,1.83C38.7,66.5,49.27,67.6,56,61.58c3.1-2.8,8.17-6.19,14.55-6.19V32.33A40.58,40.58,0,0,0,41.58,43.08a29.57,29.57,0,0,0-8.69,14,41.67,41.67,0,0,0-1,15.92c.08.75.22,1.48.35,2.22a16,16,0,0,1-2.32,11.36l-5.95,8.65S22.17,99,26.59,99.82a9.41,9.41,0,0,1,2.41.56,1.08,1.08,0,0,1,.4,1.69c-.66.76-1.26,2,.62,3.05a1.12,1.12,0,0,1,.44,1.55c-.6,1-.94,2.57,1.63,3.33a1.11,1.11,0,0,1,.79,1.26c-.6,3.11-1.67,12.27,6.75,12.14l7-.68a9.47,9.47,0,0,1,10.27,7.7,78.3,78.3,0,0,1,1,13.57",
    style: {
      fill: "none",
      stroke: "#223773",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.71,58.37a29.79,29.79,0,0,1,0,59.57",
    style: {
      fill: "none",
      stroke: "#223773",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.71,144c3.12,0,8.73-1,9.17-5.66h0a5.65,5.65,0,0,1,4-5.42A46.12,46.12,0,0,0,98,129.14a5.63,5.63,0,0,1,6.68,1h0a5.67,5.67,0,0,0,8,0l5-5a5.67,5.67,0,0,0,0-8h0a5.63,5.63,0,0,1-1-6.68,46.73,46.73,0,0,0,3.77-9.11,5.63,5.63,0,0,1,5.41-4h0a5.67,5.67,0,0,0,5.67-5.67v-7A5.67,5.67,0,0,0,125.87,79h0a5.63,5.63,0,0,1-5.41-4,46.23,46.23,0,0,0-3.77-9.11,5.62,5.62,0,0,1,1-6.68h0a5.68,5.68,0,0,0,0-8l-5-5a5.67,5.67,0,0,0-8,0h0a5.66,5.66,0,0,1-6.68,1A46.16,46.16,0,0,0,88.9,43.4a5.63,5.63,0,0,1-4-5.41h0c-.53-4.24-6-5.66-9.17-5.66",
    style: {
      fill: "none",
      stroke: "#223773",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.71,46.66V53a35.19,35.19,0,1,1,0,70.38v6.31a41.5,41.5,0,0,0,41.5-41.5C117.21,67.9,98.63,46.66,75.71,46.66Z",
    style: {
      fill: "#223773"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuality);
export default __webpack_public_path__ + "static/media/quality.1f7af3f4dbf5febea5e9576c8aab6904.svg";
export { ForwardRef as ReactComponent };